import React from "react";
import { CheckIcon } from "lucide-react";
import { SectionHeading } from "./Section";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ctaNote, finalIncludes, images } from "../data/offer";
export function FinalCTASection() {
  return <section aria-labelledby="final-title" className="bg-navy px-4 py-14 text-white sm:px-6 md:py-20" data-id="element-119" data-mp="vlbu7qpk1fj">
      <div className="mx-auto max-w-5xl" data-id="element-120" data-mp="2zdqxlwnfo5ef">
        <SectionHeading id="final-title" dark eyebrow="Ready to stop studying facelift surgery in pieces?" title={<>
              Start Organizing Your Educational Case Reviews <span className="text-gold-light" data-id="element-122" data-mp="399ljd0myeglf">With a System.</span>
            </>} sub="You don't necessarily need another lengthy lecture. You need a practical way to organize the information you're studying, identify your questions, and document what you learn." data-id="element-121" data-mp="2zf207t55773y" />

        <div className="mt-10 grid items-center gap-8 md:grid-cols-2" data-id="element-123" data-mp="2lk9ak1vjgajn">
          <img src={images.hero} alt="Facelift Blueprint™ complete system" className="mx-auto w-full max-w-lg" data-id="element-124" data-mp="26tpl67q2w9xy" />
          <div className="rounded-3xl border border-gold/40 bg-navy-800 p-6 sm:p-8" data-id="element-125" data-mp="21wfy2yq5wada">
            <p className="font-serif text-2xl font-bold" data-id="element-126" data-mp="1x3wla3zatj9j">Facelift Blueprint™</p>
            <p className="mt-1 font-semibold text-gold-light" data-id="element-127" data-mp="1s6wdnomsw8gb">6 Premium Volumes + 5 Professional Bonuses</p>
            <ul className="mt-5 space-y-2.5" data-id="element-128" data-mp="1o5kkxa8mr73w">
              {finalIncludes.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-white/90" data-id="element-129" data-mp="1j56lggl3h5hh">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-130" data-mp="1e5k17n6umoz6" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-6 text-sm font-bold uppercase tracking-[0.12em] text-white/70" data-id="element-131" data-mp="38kwagqqcnhzc">Get it today for</p>
            <p className="font-serif text-6xl font-bold leading-none text-gold-light" data-id="element-132" data-mp="33l1iejuu8mcp">
              $27 <span className="font-sans text-lg text-white" data-id="element-133" data-mp="11vubo2350qk2">USD</span>
            </p>
          </div>
        </div>

        <div className="mt-10" data-id="element-134" data-mp="16nvts4mzlbi0">
          <CTAButton label="Yes, I want Facelift Blueprint™" note={ctaNote} tone="dark" data-id="element-135" data-mp="16ox7yhzaue3y" />
          <Countdown dark data-id="element-136" data-mp="rzrc93zo760t" />
        </div>
      </div>
    </section>;
}